
import { createReducer, on } from '@ngrx/store';
import { loadBrokerConfigData, loadBrokerConfigDataSuccess, loadBrokerConfigDataFailure } from '../actions/brokerConfig.actions';

export interface State {
  brokerConfigData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  brokerConfigData: [],
  loading: false,
  error: null,
};

export const brokerConfigReducer = createReducer(
  initialState,
  on(loadBrokerConfigData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(loadBrokerConfigDataSuccess, (state, { brokerConfigData }) => {
    console.log({brokerConfigData})
    return ({
    ...state,
    loading: false,
    brokerConfigData: brokerConfigData,
  })}),
  on(loadBrokerConfigDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
